/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query SmppReadServerOwnSmppQuery {
  SmppReadServerOwnSmpp {
    id,
    ip,
    message
    status
  }
}
`
